import React, { Component } from 'react';
import Translation from '../../../components/Translation';
import NavigateIcon from '../../../components/NavigateIcon';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import {
  createContentItem,
  uploadImage,
  updateContentItem,
  fetchContentByContentId,
  deleteContentItem
} from '../../../apis/MenuContentAPI';
import TranslationItem from '../../../models/TranslationItem';
import ButtonLink from '../../../components/ButtonLink';
import FormHelperText from '@material-ui/core/FormHelperText';
import { fetchGroup } from '../../../apis/GroupAPI';
import SaveButton from '../../../components/SaveButton';
import ErrorMessage from '../../../components/ErrorMessage';
import Loading from '../../../components/Loading';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Header from '../../../components/HomeNavigation';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import '../../../../css/components/create-content.css';
import NavigationLayout from '../../../components/Layouts/NavigationLayout';
function Transition(props) {
  return <Slide direction="down" {...props} />;
}
const style = {
  buttonColor: {
    borderColor: '#FF0000'
  },
  main: {
    marginLeft: '100px',
    marginRight: '100px'
  },
  SpanStyle: {
    display: 'flex',
    alignItems: 'center'
  },
  actualValueLabel: {
    width: '50%',
    marginLeft: '5%',
    height: '40px'
  },
  ratioLabel: {
    width: '25%',
    marginLeft: '5%',
    height: '40px'
  },
  toLabel: {
    marginLeft: '2%'
  },
  helperText: {
    color: '#FF0000',
    fontSize: '12px'
  },
  caloriesDiv: {
    marginLeft: '1%'
  },
  caloriesHeader: {
    margin: '0px'
  }
};
class CreateContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      saving: false,
      uploading: false,
      imageLoading: false,
      group: null,
      id: null,
      contentId: null,
      systemName: '',
      notes: '',
      imageUrl: '',
      translations: null,
      file: null,
      formErrors: {
        systemName: false,
        systemNameError: '',
        caloriesError: ''
      },
      open: false,
      selectedCaloriesOption: null,
      actualValue: null,
      fromValue: null,
      toValue: null
    };
  }

  componentDidMount = async () => {
    const { isEdit } = this.props;

    await this.initialise();

    if (isEdit) {
      await this.setEditState();
    } else {
      await this.setCreateState();
    }
  };

  initialise = async () => {
    const { match } = this.props;
    try {
      const group = await fetchGroup(match.params.groupName);
      this.setState({ group });
    } catch (error) {
      this.setState({ error: true });
    }
  };

  setCreateState = async () => {
    const { group } = this.state;
    const translations = [];

    if (group && group.languages) {
      group.languages.forEach(language => {
        translations.push(new TranslationItem(language));
      });

      this.setState({ translations });
    }
  };

  setCaloriesEditState = calories => {
    this.setState({
      actualValue: calories.actualValue,
      fromValue: calories.fromValue,
      toValue: calories.toValue
    });

    if (calories.actualValue && calories.actualValue > 0) {
      this.setState({ selectedCaloriesOption: '1' });
    } else if (
      (calories.fromValue && calories.fromValue > 0) ||
      (calories.toValue && calories.toValue > 0)
    ) {
      this.setState({ selectedCaloriesOption: '2' });
    }
  };

  setEditState = async () => {
    const { match } = this.props;
    const { group } = this.state;

    try {
      const {
        id,
        contentId,
        systemName,
        notes,
        imageUrl,
        translations,
        calories
      } = await fetchContentByContentId(match.params.contentId);

      const populatedTranslations = [];
      group.languages.forEach(language => {
        const { name, description, shortName } =
          translations.find(item => item.language === language) || {};
        populatedTranslations.push(
          new TranslationItem(language, name, shortName, description)
        );
      });

      if (imageUrl) {
        this.setState({ imageLoading: true });
      }

      this.setState({
        id,
        contentId,
        systemName,
        notes,
        imageUrl,
        translations: populatedTranslations
      });
      if (calories) {
        this.setCaloriesEditState(calories);
      }
    } catch (error) {
      this.setState({ error: true });
    }
  };

  translationChange = (language, field, value) => {
    let translations = [...this.state.translations];
    let translationIndex = translations.findIndex(
      item => item.language === language
    );
    translations[translationIndex][field] = value;
    this.setState({
      translations
    });
  };

  fieldChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  saveContent = async () => {
    if (!this.isFormValid() || !this.validateRatio()) {
      return;
    }

    const {
      group,
      id,
      contentId,
      systemName,
      notes,
      imageUrl,
      translations,
      fromValue,
      toValue,
      actualValue,
      selectedCaloriesOption
    } = this.state;
    const { isEdit } = this.props;
    let calories = {
      actualValue: null,
      fromValue: null,
      toValue: null
    };

    if (selectedCaloriesOption === '1') {
      calories.actualValue = actualValue;
    } else {
      if (toValue > 0 && fromValue > 0) {
        calories.fromValue = fromValue;
        calories.toValue = toValue;
      } else if (toValue > 0) {
        calories.toValue = toValue;
      } else if (fromValue > 0) {
        calories.fromValue = fromValue;
      }
    }

    let content = {
      id,
      contentId,
      systemName,
      notes,
      imageUrl,
      group: group.name,
      translations,
      calories: calories
    };
    const saveFunc = isEdit
      ? updateContentItem(id, content)
      : createContentItem([content]);

    try {
      this.setState({ saving: true });
      await saveFunc;
      this.props.history.push(
        `/channel/${group.channelId}/groups/${group.name}`
      );
    } catch (error) {
      this.setState({ saving: false });
      //check if error code is unknown
    }
  };

  selectFile = async event => {
    const { group } = this.state;
    const file = event.target.files[0];
    if (file) {
      try {
        this.setState({ uploading: true });
        const response = await uploadImage(
          group.channelId,
          event.target.files[0]
        );
        this.setState({
          imageUrl: response.url,
          uploading: false
        });
      } catch (error) {
        //Throw an error
        this.setState({ uploading: false });
      }
    }
  };

  isFormValid = () => {
    const { systemName } = this.state;
    const valid = systemName && systemName.trim();
    this.setState({
      formErrors: {
        systemName: !valid,
        systemNameError: 'System Name is required.'
      }
    });
    return valid;
  };

  handleImageLoaded = () => {
    this.setState({ imageLoading: false });
  };

  deleteContent = async () => {
    try {
      await deleteContentItem(this.state.contentId);
      this.setState({ open: false });
      this.props.history.push(
        `/channel/${this.state.group.channelId}/groups/${this.state.group.name}`
      );
    } catch (error) {
      //Need to Add the snackbar code here to show failure message
    }
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  validateRatio = () => {
    const { fromValue, toValue, selectedCaloriesOption } = this.state;
    if (selectedCaloriesOption === '1') {
      return true;
    }

    if (fromValue > 0 && toValue > 0 && fromValue > toValue) {
      this.setState({
        formErrors: {
          caloriesError: 'From value must be less than to value'
        }
      });
      return false;
    } else {
      return true;
    }
  };

  handleChange = name => event => {
    if (event.target.value < 0) {
      this.setState({
        formErrors: {
          caloriesError: 'Calories must be more than 0'
        }
      });
    } else {
      if (name === 'actualValue') {
        this.setState({ selectedCaloriesOption: '1' });
      } else {
        this.setState({ selectedCaloriesOption: '2' });
      }
      let value = parseInt(event.target.value, 0);
      this.setState({ [name]: value });
    }
  };

  render() {
    const { match, isEdit } = this.props;
    const {
      error,
      group,
      saving,
      uploading,
      imageLoading,
      contentId,
      systemName,
      notes,
      imageUrl,
      translations,
      formErrors
    } = this.state;
    const formLoading = saving || uploading;

    if (!group || !translations) {
      return error ? <ErrorMessage /> : <Loading />;
    }

    const actualValueLabel = (
      <div>
        <span style={style.SpanStyle}>
          <div>{`Actual Value :`}</div>
          <TextField
            type="number"
            value={this.state.actualValue ? this.state.actualValue : ''}
            style={style.actualValueLabel}
            onChange={this.handleChange('actualValue')}
          />
        </span>
      </div>
    );

    const ratioLabel = (
      <div>
        <span style={style.SpanStyle}>
          <div>{`From :`}</div>
          <TextField
            type="number"
            value={this.state.fromValue ? this.state.fromValue : ''}
            style={style.ratioLabel}
            onChange={this.handleChange('fromValue')}
          />
          <div style={style.toLabel}>{`To :`}</div>
          <TextField
            type="number"
            value={this.state.toValue ? this.state.toValue : ''}
            style={style.ratioLabel}
            onChange={this.handleChange('toValue')}
          />
        </span>
      </div>
    );

    return (
      <NavigationLayout>
        <div>
          <Header isTitle={true} isOperatorHome={false} isGroupHome={false} />
          <div id="create-content" style={style.main}>
            <NavigateIcon
              to={`/channel/${match.params.channelId}/groups/${
                match.params.groupName
              }`}
              id="navigate-back-group"
            />
            <h2>{isEdit ? 'Edit' : 'Create'} Content</h2>
            <h3>
              {group.name}
              {contentId && ' - ' + contentId}
            </h3>
            <Paper elevation={1}>
              <div id="create-content-form">
                <fieldset style={{ borderStyle: 'hidden' }}>
                  <Grid container justify="center">
                    <Grid item xs>
                      <FormControl className="form-element">
                        <TextField
                          id="systemName"
                          required
                          disabled={formLoading}
                          value={systemName}
                          error={formErrors.systemName}
                          onChange={this.fieldChange('systemName')}
                          label="System Name"
                          margin="normal"
                        />
                        <FormHelperText
                          hidden={!formErrors.systemName}
                          id="name-error-text"
                        >
                          {formErrors.systemNameError}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs>
                      <FormControl className="form-element">
                        <TextField
                          id="notes"
                          disabled={formLoading}
                          multiline
                          rowsMax="4"
                          value={notes}
                          onChange={this.fieldChange('notes')}
                          label="Notes"
                          margin="normal"
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs />
                  </Grid>
                </fieldset>
                <br />
                {group.languages.map(lang => {
                  let translation = translations.find(
                    item => item.language === lang
                  );
                  if (translation) {
                    return (
                      <div key={lang}>
                        <Translation
                          saving={formLoading}
                          handleChange={this.translationChange}
                          language={lang}
                          name={translation.name || ''}
                          shortName={translation.shortName || ''}
                          description={translation.description || ''}
                          {...this.props}
                        />
                      </div>
                    );
                  }
                  return '';
                })}
                <fieldset style={{ borderStyle: 'hidden' }}>
                  <Grid container justify="center">
                    <Grid item xs>
                      <FormControl className="form-element">
                        <SaveButton
                          id="btn-upload-image"
                          disabled={formLoading}
                          saving={uploading.toString()}
                          variant="outlined"
                          color="primary"
                          component="label"
                        >
                          Upload Image
                          <input
                            type="file"
                            onChange={this.selectFile}
                            style={{ display: 'none' }}
                          />
                        </SaveButton>
                      </FormControl>
                    </Grid>
                  </Grid>
                </fieldset>
                {imageUrl && (
                  <fieldset style={{ borderStyle: 'hidden' }}>
                    <Grid container justify="center">
                      <Grid item xs>
                        <FormControl
                          className="form-element"
                          aligns="center"
                          style={{ alignItems: 'center' }}
                        >
                          <a
                            href={imageUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={imageUrl}
                              alt=""
                              onLoad={this.handleImageLoaded}
                              onError={this.handleImageLoaded}
                            />
                          </a>
                          {imageLoading && (
                            <Loading
                              size={24}
                              style={{ position: 'absolute' }}
                            />
                          )}
                        </FormControl>
                      </Grid>
                    </Grid>
                  </fieldset>
                )}

                <div style={style.caloriesDiv}>
                  <h3 style={style.caloriesHeader}>{`Calories`}</h3>
                  <FormControl
                    className="form-element"
                    aria-describedby="name-error-text"
                  >
                    <RadioGroup
                      required
                      value={
                        this.state.selectedCaloriesOption
                          ? this.state.selectedCaloriesOption.toString()
                          : ''
                      }
                      onChange={this.fieldChange('selectedCaloriesOption')}
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio color="primary" />}
                        label={actualValueLabel}
                      />
                      <FormControlLabel
                        value="2"
                        control={<Radio color="primary" />}
                        label={ratioLabel}
                      />
                    </RadioGroup>
                  </FormControl>
                  <FormHelperText id="name-error-text">
                    {this.state.formErrors.caloriesError && (
                      <span style={style.helperText}>
                        {this.state.formErrors.caloriesError}
                      </span>
                    )}
                    {!this.state.formErrors.caloriesError && (
                      <span>Enter Actual Value or Range (From / To)</span>
                    )}
                  </FormHelperText>
                </div>
                <div className="form-element">
                  <div className="right">
                    {isEdit && (
                      <Button
                        id="btn-delete"
                        onClick={this.handleClickOpen}
                        variant="outlined"
                        style={style.buttonColor}
                        className="cancel-margin"
                      >
                        Delete
                      </Button>
                    )}
                    <ButtonLink
                      id="btn-cancel"
                      disabled={formLoading}
                      path={`/channel/${match.params.channelId}/groups/${
                        match.params.groupName
                      }`}
                      variant="outlined"
                      color="primary"
                      className="cancel-margin"
                    >
                      Cancel
                    </ButtonLink>
                    <SaveButton
                      id="btn-save-content"
                      saving={saving.toString()}
                      disabled={formLoading}
                      onClick={this.saveContent}
                      variant="contained"
                      color="primary"
                      className="right"
                    >
                      Save
                    </SaveButton>
                  </div>
                  <Dialog
                    open={this.state.open}
                    TransitionComponent={Transition}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-slide-title"
                  >
                    <DialogTitle id="alert-dialog-slide-title">{`Are you sure you want to delete "${
                      this.state.systemName
                    }" ?`}</DialogTitle>
                    <DialogActions>
                      <Button onClick={this.handleClose}>NO</Button>
                      <Button onClick={this.deleteContent} autoFocus>
                        YES
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              </div>
            </Paper>
          </div>
        </div>
      </NavigationLayout>
    );
  }
}

export default CreateContent;
